export default __webpack_public_path__ + "locales/zh-CN/Payments.json?hash=30c0994fe59411de3495a5151fb28b84";